export default __webpack_public_path__ + "static/media/classic03.e2bbf9a3.png";